import {DigitalPageItem} from '../../interfaces/digital-page-item';
import {ProductTypeEnum} from '../../interfaces/product-type-enum';

export const DigitalProductPageItem: DigitalPageItem = {
  ProductType: ProductTypeEnum.Paid,
  Title: 'Hello!',
  ProductCode: 'hecpo43',
  Description:
    'Here\'s all the online content included with your <strong>Crime and Punishment in Britain Complete Revision and Practice</strong>.',
  Credits:
    '<i>Proofreader: Elizabeth Walkden</i> <br />' +
    '<i>Bulls Eye Engraving by Gustave Dore: © Lebrecht Music & Arts / Alamy Stock Photo</i> <br />' +
    '<i>Extract from \'A Night in Whitechapel\' from the British Library Collection:  MFM.MLD9, The Morning Post, 8 October 1872, page 6.</i> <br />' +
    '<i>Extract from anonymous letter about Thrawl Street from the British Library Collection: ZD.9.d.175, The Daily Telegraph, 21 September 1888, page 3. Questions throughout are based on Pearson Edexcel type questions.</i> <br />' +
    'Questions throughout based on Pearson Edexcel type questions. <br />' +
    'Text, design, layout and original illustrations © Coordination Group Publications Ltd. (CGP) 2026. All rights reserved.</i>',};